<template>
  <div class="LoginForm d-flex flex-column h-100">
    <h1 class="text-center mb-4 pb-2">Account activatie</h1>
    <div style="min-height: 60px">
      <Feedback :feedback="feedback" />
    </div>
    <Form 
      class="flex-grow-1"
      @submit="handleSubmit">
      
      <FormField 
        v-model="fields.password.value"
        v-bind="fields.password"
        class="mt-2" />
      
      <button 
        type="submit"
        :disabled='isDisabled'
        class="btn btn-success btn-lg btn-block rounded-pill font-weight-bold border-0 mt-3 p-3">
        Account activeren
      </button>
    </Form>

    <div class="d-flex justify-content-center mt-5">
      <router-link 
        class="text-muted"
        :to="{ name: 'login' }">
        Annuleren
      </router-link>
    </div>
  </div>
</template>

<script>
import { acceptInvite, getUser } from 'service/auth'
import { mapMutations } from 'vuex'

import { required } from 'vuelidate/lib/validators';

import Feedback from 'atom/Feedback'
import Form from 'molecule/form/Form'
import FormField from 'molecule/form/FormField'

import fields from 'mixin/fields'
import timeout from 'mixin/timeout'

export default {
  name: 'RecoverForm',
  components: {
    Feedback,
    Form,
    FormField
  },
  mixins: [ fields, timeout ],
  data() {
    return {
      feedback: {},
      isDisabled: false,
      token: '',
      fields: {
        password: {
          label: "Wachtwoord",
          autocomplete: "new-password",
          type: "password",
          value: '',
          validationRules: {
            required
          },
          disabled: false
        }
      }
    }
  },
  created() {
    if (this.$route.hash) {
      // Get the token, after #recovery_token=
      this.token = this.$route.hash.split("=").pop()
      
      // Clear hash from route
      this.$router.push({ name: this.$route.name })
    }

    if (this.token === '') {
      this.feedback = {
        variant: 'danger', 
        message: 'Geen uitnodigingscode ontvangen.'
      }
      this.disableAllFields()
      this.isDisabled = true
    }
  },
  methods: {
    ...mapMutations('user', [
      'setUser'
    ]),
    handleSubmit(e) {
      e.preventDefault();
      
      this.disableAllFields()
      this.isDisabled = true
      this.feedback = {
        variant: 'info', 
        message: 'Bezig met activeren...'
      }

      acceptInvite({
        token: this.token,
        password: this.fieldValue('password')
      })
        .then(() => {
          this.feedback = {
            variant: 'success', 
            message: 'Uw account is actief. U wordt automatisch ingelogd.'
          }
          this.setUser({ authenticatedUser: getUser() })
          this.setTimeout(() => {
            this.$router.push({ name: 'home' })
          }, 2000)
        })
        .catch((err) => {
          this.enableAllFields()
          
          this.isDisabled = false
          if (err && err.status === 401) {
            this.feedback = {
              variant: 'danger', 
              message: 'Uw wachtwoord is niet opgeslagen'
            }
          } else {
            this.feedback = {
              variant: 'danger', 
              message: 'Onbekende fout. Probeer het later nog eens.'
            }
          }
        })
    },
  }
}
</script>
